exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PaymentMethodForm__formGroup>*{margin-bottom:8px}.PaymentMethodForm__formGroup>:last-child{margin-bottom:20px}.PaymentMethodForm__block{display:block;width:100%}", ""]);

// exports
exports.locals = {
	"formGroup": "PaymentMethodForm__formGroup",
	"block": "PaymentMethodForm__block"
};